import React, { useState, useCallback, useEffect, useRef } from "react";
import { Grid, Button, Menu, MenuItem } from "@mui/material";
import { ViewColumn, FilterList, GetApp } from "@mui/icons-material";

import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import SearchBox_new from "../../FilterOptions/SearchComponent/SearchBox_new";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import {
  useEquipmentStatusActionsContext,
  useItemSelectedFilterActionsContext,
  useItemSelectedFilterContext,
} from "../../../Context/GridEquipListContext";
import {
  useAMGSelectedContext,
  useCurrentPageActionContext,
  useMainGridSortContext,
} from "../../../Context/GlobalContext";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useSelectedFilterContext } from "../../../Context/GridEquipListContext";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import { useLanguageContext } from "../../../Context/LanguageContext";
import MessageBox from "../../MessageBox/MessageBox";
import { toast } from "react-toastify";
import equipmentStore from "../../../Stores/EquipmentStore";
import equipmentConstants from "../../../Constants/EquipmentConstants";
import DropDownButton from "./DropDownButton";
import { _helper } from "../../GlobalFunction/dateHelper";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";
const initialMsg = {
  messageBoxText: {},
  msgButtons: [],
  messageBoxOpen: false,
};

export default function LeftSideButton({
  gridAction,
  reportCode,
  saveFilterList,
  selectedEqList,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateEquipmentStatus = useEquipmentStatusActionsContext();
  const UpdateCurrentPage = useCurrentPageActionContext();
  const selectedFilter = useSelectedFilterContext();
  const sortBy = useMainGridSortContext();
  const selectedAnlageG = useAMGSelectedContext();
  var dateFormat = require("dateformat");
  const [state, setState] = useState(
    reportCode === "EquipList" ? "All" : "Last 30 days"
  );
  const [stateAnchorEl, setStateAnchorEl] = useState(null);

  const [showFilter, setShowFilter] = useState(false);
  const itemSelectedRef = useRef(null);
  const [conditions, setConditions] = useState([]);
  const [messageBoxOpen, setMessageBoxOpen] = useState(initialMsg);
  const [exportData, setExportData] = useState(null);

  const toggleFilter = (_value) => {
    setShowFilter(_value);
  };

  const handleStateClick = (event) => {
    if (showFilter) {
      setShowFilter(false);
    }
    setStateAnchorEl(event.currentTarget);
  };

  const handleStateClose = (newState) => {
    if (newState) {
      const updatedConditions = [...conditions];
      setState(newState);
      updateEquipmentStatus(newState);

      const isEquipListReport = reportCode === "EquipList";
      const isAllState = newState === "All";

      if (!isAllState && newState !== state) {
        const filteredConditions = updatedConditions.filter(
          (item) => !["LastCheckDate", "AnlageStatus"].includes(item.Name)
        );
        const filter = isEquipListReport
          ? {
              Name: "AnlageStatus",
              Value: newState === "Active" ? "INBE" : "AUSSER BETRIEB",
              Operator: "=",
            }
          : {
              Name: "LastCheckDate",
              Value: _helper.lastCheckDateFromCurrent(
                newState === "Last 30 days"
                  ? 30
                  : newState === "Last 2 month"
                  ? 60
                  : 90
              ),
              Operator: ">",
            };
        filteredConditions.push(filter);
        updatedConditions.length = 0;
        updatedConditions.push(...filteredConditions);
        updateListSelectedFilter(updatedConditions);
        setConditions(updatedConditions);
      } else {
        const filteredConditions = updatedConditions.filter(
          (item) => !["LastCheckDate", "AnlageStatus"].includes(item.Name)
        );
        updatedConditions.length = 0;
        updatedConditions.push(...filteredConditions);
        updateListSelectedFilter(updatedConditions);
        setConditions(updatedConditions);
      }

      handleEquipmentListApi(updatedConditions, newState, true);
    }
    setStateAnchorEl(null);
  };

  const handleConditionChange = useCallback((_value) => {
    setConditions((prev) => _value);
  }, []);

  const filterOutNull = () => {
    const notNullList = conditions.filter((item) => {
      if (item.Operator === "#") {
        return true;
      } else {
        return item.Value.trim() !== "";
      }
    });
    return notNullList;
  };

  let handleDownload = (bildOption) => {
    const FilterId = selectedFilter.length > 0 ? selectedFilter[0].id : null;
    setGlobalSpinner(true);

    equipmentGroupActions.getExportDaten(
      selectedAnlageG,
      bildOption,
      [...itemSelectedRef.current],
      reportCode,
      FilterId
    );
    setMessageBoxOpen(initialMsg);
  };

  const downloadMitBilderEvent = () => {
    handleDownload("with");
  };

  const downloadOhneBilderEvent = () => {
    handleDownload("none");
  };

  const downloadEvent = (event) => {
    event.preventDefault();
    setMessageBoxOpen({
      messageBoxText: {
        title: "Export-Export",
        msg: localization.downloadMsg,
        anlageID: 0,
      },
      msgButtons: [
        {
          title: localization.cancelbutton,
          func: () => setMessageBoxOpen(initialMsg),
        },
        {
          title: localization.exportWithimg,
          func: downloadMitBilderEvent,
        },
        {
          title: localization.exportWithoutImg,
          func: downloadOhneBilderEvent,
        },
      ],
      messageBoxOpen: true,
    });
  };

  useEffect(() => {
    itemSelectedRef.current = itemSelectedFilter;
  }, [itemSelectedFilter]);

  useEffect(() => {
    setShowFilter(false);
    updateListSelectedFilter([]);
    setConditions([]);
  }, [selectedAnlageG]);

  useEffect(() => {
    function getSaveFilterValueSuccess() {
      const res = gridColSettingStore.getSavedFilterValueResult();
      if (res.length > 0) {
        handleEquipmentListApi(res, state, false);
        updateListSelectedFilter(res);
        setConditions(res);
      } else {
        setGlobalSpinner(false);
      }
    }

    function getSaveFilterValueFailure() {
      setGlobalSpinner(false);
      updateListSelectedFilter([]);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS,
      getSaveFilterValueSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE,
      getSaveFilterValueFailure
    );

    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_SUCCESS,
        getSaveFilterValueSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_VALUE_FAILURE,
        getSaveFilterValueFailure
      );
    };
  }, []);

  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterResult();
      if (res) {
        toggleFilter(false);
        toast.success(localization.filterSave);
        handleEquipmentListApi(
          [...JSON.parse(res["settingValue"])],
          state,
          false
        );
        GridColumn_SettingActions.getSaveFilterList(
          sessionStorage.getItem("eqGId"),
          reportCode
        );
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
      getFilterSaveSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
      getFilterSaveFailure
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
        getFilterSaveSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
        getFilterSaveFailure
      );
    };
  }, []);

  /**------------------------------------------Lister to listen copy and delete equipment start ------------------- */
  useEffect(() => {
    function refreshTable() {
      toast.success(localization.deleteSuccess);
      handleEquipmentListApi([...conditions], state, true);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.DELETE_EQUIPMENT_SUCCESS,
      refreshTable
    );

    //RefreshData();

    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.DELETE_EQUIPMENT_SUCCESS,
        refreshTable
      );
    };
  }, []); //refresh

  useEffect(() => {
    function refreshTable() {
      const res = equipmentStore.getResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.DELETE_EQUIPMENT_FAILURE,
      refreshTable
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.DELETE_EQUIPMENT_FAILURE,
        refreshTable
      );
    };
  }, []); //refresh

  // useEffect(() => {
  //   function refreshTable() {
  //     var res = equipmentStore.getResult();
  //     let msg = "";
  //     if (res && res.length) {
  //       msg = "" + localization.copySuccess + "\n" + res.join();
  //     } else {
  //       msg = "" + localization.copySuccess + "\n" + res;
  //     }

  //     handleEquipmentListApi([...conditions], state, true);
  //     toast.success(msg);
  //   }

  //   equipmentStore.addChangeListener(
  //     equipmentConstants.COPY_EQUIPMENT_SUCCESS,
  //     refreshTable
  //   );

  //   return () => {
  //     equipmentStore.removeChangeListener(
  //       equipmentConstants.COPY_EQUIPMENT_SUCCESS,
  //       refreshTable
  //     );
  //   };
  // }, []);

  useEffect(() => {
    function refreshTable() {
      setGlobalSpinner(false);
      toast.error(localization.copyFailure);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.COPY_EQUIPMENT_FAILURE,
      refreshTable
    );

    return () => {
      equipmentStore.addChangeListener(
        equipmentConstants.COPY_EQUIPMENT_FAILURE,
        refreshTable
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      toast.success(localization.updateSuccess);
      handleEquipmentListApi([...conditions], state, true);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS,
      updateData
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.UPDATE_EQUIPMENTSTATUS_SUCCESS,
        updateData
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      toast.success(localization.updateError);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
      updateData
    );

    return () => {
      equipmentStore.removeChangeListener(
        equipmentConstants.UPDATE_EQUIPMENTSTATUS_FAILURE,
        updateData
      );
    };
  }, []);

  useEffect(() => {
    if (exportData !== null && exportData !== undefined) {
      const url = window.URL.createObjectURL(exportData);
      let a = document.createElement("a");
      let name =
        "Export_" + dateFormat(Date(), "yyyy-mm-dd_hh-mm-ss") + ".xlsx";

      a.hidden = "";
      a.href = url;
      a.download = name;
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [exportData]);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getExport();
      setExportData(tmp);
      // setNavItem(equipmentGroupStore.getNavbarItem());
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_SUCCESS,
      updatData
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_SUCCESS,
        updatData
      );
    };
  }, []);

  useEffect(() => {
    function updatData() {
      var tmp = equipmentGroupStore.getExport();
      toast.error(tmp);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.EXPORT_FAILURE,
      updatData
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.EXPORT_FAILURE,
        updatData
      );
    };
  }, []);
  /**------------------------------------------Lister to listen copy and delete equipment start ------------------- */

  function handleEquipmentListApi(_filtervalue, newState, isActiveDropChange) {
    const FilterId = null;

    setGlobalSpinner(true);
    equipmentGroupActions.getEquipmentList2(
      reportCode,
      sortBy.order,
      selectedAnlageG,
      parseInt(1),
      parseInt(gridAction.pageInfo.pagSize),
      sortBy.key,
      FilterId,
      _filtervalue
    );
    toggleFilter(false);
    // if (gridAction.pageInfo.currentPage === 1) {
    //   UpdateCurrentPage(1);
    // }
  }

  function handleButtonClick(e, functionName) {
    // if (showFilter) {
    //   setShowFilter(false);
    // }
    switch (functionName) {
      // case "DataConfiguration":
      //   setGlobalSpinner(true);
      //   setShowGridColumn(true);
      //   break;
      case "ExcelExport":
        downloadEvent(e);
        break;
    }
  }

  function getEquipmentBasedFilter() {
    setGlobalSpinner(true);
    const _temp = filterOutNull();
    handleEquipmentListApi(_temp, state, false);
    updateListSelectedFilter(_temp);
  }

  function handleFilterSave(fieldName) {
    const filterDetails = {
      ID:
        selectedFilter.length > 0
          ? selectedFilter[0].title === fieldName
            ? selectedFilter[0].id
            : null
          : null,
      eqgID: sessionStorage.getItem("eqGId"),
      ReportCode: reportCode,
      SettingType: "Filter",
      Title: fieldName,
      SettingValue: conditions,
    };
    setGlobalSpinner(true);
    GridColumn_SettingActions.saveFilterGrid(filterDetails);
  }

  function closeMsg() {
    setMessageBoxOpen(initialMsg);
  }

  function handleDelFilterSuccess() {
    handleEquipmentListApi([], state, true);
    GridColumn_SettingActions.getSaveFilterList(selectedAnlageG, reportCode);
  }

  function handleCancel() {
    if (itemSelectedRef.current.length === 0) {
      setConditions([]);
    }
    toggleFilter(false);
  }

  return (
    <>
      <Grid item>
        {!selectedEqList && (
          <>
            {/* <Button
              startIcon={<FilterList />}
              variant="contained"
              className="gridTableButton gridTableButtonStyle"
              style={{ marginLeft: 8 }}
              onClick={() => {
                toggleFilter(!showFilter);
              }}
              disabled={gridAction.filterList.length === 0}
            >
              {localization.filter}
            </Button> */}
            {gridAction["actionName"]["ExcelExport"] && (
              <Button
                startIcon={<GetApp />}
                variant="contained"
                className="gridTableButton gridTableButtonStyle"
                style={{ marginLeft: 8 }}
                onClick={(e) =>
                  handleButtonClick(
                    e,
                    gridAction["actionName"]["ExcelExport"]["name"]
                  )
                }
              >
                {localization.exportTitle}
              </Button>
            )}
            {/* <DropDownButton
              reportCode={reportCode}
              state={state}
              handleStateClick={handleStateClick}
              stateAnchorEl={stateAnchorEl}
              handleStateClose={handleStateClose}
            /> */}
          </>
        )}
      </Grid>

      {/* {showFilter && (
        <SearchBox_new
          filterList={gridAction.filterList}
          saveFilterList={saveFilterList}
          conditions={conditions}
          setConditions={handleConditionChange}
          toggleFilter={handleCancel}
          reportCode={reportCode}
          handleFilterOpertation={getEquipmentBasedFilter}
          handleFiltersave={handleFilterSave}
          handleDelFilterSuccess={handleDelFilterSuccess}
          isShowSaveFilterDropDown={true}
          showSaveButton={true}
        />
      )} */}
      <MessageBox
        isOpen={messageBoxOpen.messageBoxOpen}
        text={messageBoxOpen.messageBoxText}
        functions={messageBoxOpen.msgButtons}
        close={closeMsg}
      />
    </>
  );
}
